import { Address } from 'models/Address/address.model';
import { MultipleOrigins } from 'models/MultipleOrigins/multipleOrigins.model';
import { serializable, alias, object, list, primitive } from 'serializr';

export class ProductRawMaterial {
  @serializable(alias('id', primitive()))
  id?: number;

  @serializable(alias('product_id', primitive()))
  productId?: number;

  @serializable(alias('activity_mapping_region_spec_id', primitive()))
  activityMappingRegionSpecId?: number;

  @serializable(alias('type', primitive()))
  type?: string;

  @serializable(alias('origin', primitive()))
  origin?: string;

  @serializable(alias('quantity', primitive()))
  quantity?: string;

  @serializable(alias('unit', primitive()))
  unit?: string;

  @serializable(alias('co2e', primitive()))
  co2e?: string;

  @serializable(alias('normalised_co2e', primitive()))
  normalisedCo2e?: number;

  @serializable(alias('sum_of_normalised_co2e', primitive()))
  sumOfNormalisedCo2e?: number;

  @serializable(alias('weight', primitive()))
  weight?: string;

  @serializable(alias('user_location_label', primitive()))
  userLocationLabel?: string;

  @serializable(alias('activity_label', primitive()))
  activityLabel?: string;

  @serializable(alias('units_per_packaging_material', primitive()))
  unitsPerPackagingMaterial?: string;

  @serializable(alias('address', object(Address)))
  address?: Address;

  @serializable(alias('normalised_co2e_stage', primitive()))
  normalisedCo2eStage?: number;

  @serializable(alias('sum_of_normalised_co2e_stage', primitive()))
  sumOfNormalisedCo2eStage?: number;

  @serializable(alias('multiple_origin', list(object(MultipleOrigins))))
  multipleOrigins?: MultipleOrigins[];

  @serializable(alias('sum_of_co2e', primitive()))
  sumOfCo2e?: number;

  @serializable(alias('total_qty', primitive()))
  totalQuantity?: number;
}
